export default "__VITE_ASSET__B7OvzDB9__"